import { Routes } from '@angular/router';

export const logAnalysisRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./log-analysis.component').then((m) => m.LogAnalysisComponent),
  },
];
